import DevicesList from './DevicesList';
import DeviceType from './DeviceType';

export default DevicesList;
export { DeviceType };
